export function decode(token) {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace('-', '+').replace('_', '/');
    return JSON.parse(atob(base64));
  } catch (err) {
    return null;
  }
}
